import React, {
    ReactElement,
    useRef,
    useMemo,
    useCallback,
} from 'react'
import { AgGridReact } from 'ag-grid-react'
import { CellDoubleClickedEvent } from 'ag-grid-community'
import { AGDataGrid, StandardModal } from 'components'
import { ExtendedColumn } from 'components/DataGrid/ExtendedColumn'

interface ICaseHistoryModalProps {
    openCaseHistoryModal: boolean
    onClose: () => void
    caseInfo: any
    testId?: string
}

const CaseHistoryModal = ({
    openCaseHistoryModal,
    onClose,
    caseInfo,
    testId = 'caseHistoryModal',
}: ICaseHistoryModalProps): ReactElement => {
    const { case_no, mockHistoryData } = caseInfo
    const gridRef = useRef<AgGridReact>(null)

    // Use mock data instead of API calls
    const historyData = mockHistoryData || []
    const isLoading = false
    const pageSize = 5
    const page = 1
    const paginationTotal = historyData.length
    
    const dataSource = useMemo(() => ({
        getRows: (params: any) => {
            const startRow = params.startRow || 0
            const endRow = params.endRow || historyData.length
            const rowsThisPage = historyData.slice(startRow, endRow)
            params.successCallback(rowsThisPage, historyData.length)
        }
    }), [historyData])
    
    const setLocalPage = () => {}
    const handlePageLimitChange = () => {}

    const columns: ExtendedColumn[] = [
        {
            Header: 'Timestamp',
            accessor: 'timestamp',
            type: 'string',
            width: 180,
            minWidth: 180,
            maxWidth: 180,
            tooltipField: 'timestamp',
        },
        {
            Header: 'Username',
            accessor: 'user',
            type: 'string',
            width: 160,
            minWidth: 170,
            maxWidth: 160,
            tooltipField: 'user',
        },
        {
            Header: 'Action',
            accessor: 'action',
            type: 'string',
            autoHeight: true,
            wrapText: true,
            minWidth: 400,
            tooltipField: 'action',
        },
    ]

    const defaultColDef = {
        flex: 1,
        minWidth: 100,
        resizable: true,
        menuTabs: [],
        sortable: false,
    }

    const handleDoubleClickedCell = useCallback((e: CellDoubleClickedEvent) => {
        // Double click functionality can be added here if needed
        console.log('Cell double clicked:', e.colDef.field)
    }, [])

    const handleOnClose = () => {
        onClose()
    }

    return (
        <StandardModal
            openModal={openCaseHistoryModal}
            onModalClose={handleOnClose}
            modalHeaderTitle={`Case History (Case No: ${case_no})`}
            enablePrimaryActionBtn={false}
            enableSecondaryActionBtn={false}
            testId={testId}
            className={'emp-caseHistoryModal-modalContainer'}
            maxModalWidth={'xl'}
        >
            <div className={'emp-caseHistoryModal-gridContainer'}>
                <AGDataGrid
                    gridRef={gridRef}
                    gridName={'caseHistoryModal'}
                    fileName={'case-history'}
                    columns={columns}
                    defaultColDef={defaultColDef}
                    dataSource={dataSource}
                    loading={isLoading}
                    testId={'caseHistoryModal'}
                    rowSelectionType={'single'}
                    disableRowClickSelection
                    enableSideBarPanel={false}
                    enableDataGridTopBorder={false}
                    rowsPerPageOptions={[5, 10]}
                    totalEntries={paginationTotal}
                    onPageLimitChange={handlePageLimitChange}
                    pageSize={pageSize}
                    page={page}
                    onPageChange={setLocalPage}
                    paginate={false}
                    handleDoubleClickedCell={handleDoubleClickedCell}
                    className={'emp-caseHistoryModal-dataGrid'}

                    gridThemeType={'material'}
                />
            </div>
        </StandardModal>
    )
}

export default CaseHistoryModal
